import _core from "./core";

var _global = typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : global;

var exports = {};

// player & autoPlay
(function (window, factory) {
  // universal module definition
  if (exports) {
    // CommonJS
    exports = factory(_core);
  } else {
    // browser global
    factory(window.Flickity);
  }
})(typeof window != "undefined" ? window : exports, function factory(Flickity) {
  // -------------------------- Player -------------------------- //
  function Player(autoPlay, onTick) {
    (this || _global).autoPlay = autoPlay;
    (this || _global).onTick = onTick;
    (this || _global).state = "stopped"; // visibility change event handler

    (this || _global).onVisibilityChange = (this || _global).visibilityChange.bind(this || _global);
    (this || _global).onVisibilityPlay = (this || _global).visibilityPlay.bind(this || _global);
  } // start play


  Player.prototype.play = function () {
    if ((this || _global).state === "playing") return; // do not play if page is hidden, start playing when page is visible

    let isPageHidden = document.hidden;

    if (isPageHidden) {
      document.addEventListener("visibilitychange", (this || _global).onVisibilityPlay);
      return;
    }

    (this || _global).state = "playing"; // listen to visibility change

    document.addEventListener("visibilitychange", (this || _global).onVisibilityChange); // start ticking

    this.tick();
  };

  Player.prototype.tick = function () {
    // do not tick if not playing
    if ((this || _global).state !== "playing") return; // default to 3 seconds

    let time = typeof (this || _global).autoPlay == "number" ? (this || _global).autoPlay : 3000; // HACK: reset ticks if stopped and started within interval

    this.clear();
    (this || _global).timeout = setTimeout(() => {
      this.onTick();
      this.tick();
    }, time);
  };

  Player.prototype.stop = function () {
    (this || _global).state = "stopped";
    this.clear(); // remove visibility change event

    document.removeEventListener("visibilitychange", (this || _global).onVisibilityChange);
  };

  Player.prototype.clear = function () {
    clearTimeout((this || _global).timeout);
  };

  Player.prototype.pause = function () {
    if ((this || _global).state === "playing") {
      (this || _global).state = "paused";
      this.clear();
    }
  };

  Player.prototype.unpause = function () {
    // re-start play if paused
    if ((this || _global).state === "paused") this.play();
  }; // pause if page visibility is hidden, unpause if visible


  Player.prototype.visibilityChange = function () {
    let isPageHidden = document.hidden;
    this[isPageHidden ? "pause" : "unpause"]();
  };

  Player.prototype.visibilityPlay = function () {
    this.play();
    document.removeEventListener("visibilitychange", (this || _global).onVisibilityPlay);
  }; // -------------------------- Flickity -------------------------- //


  Object.assign(Flickity.defaults, {
    pauseAutoPlayOnHover: true
  });

  Flickity.create.player = function () {
    (this || _global).player = new Player((this || _global).options.autoPlay, () => {
      this.next(true);
    });
    this.on("activate", (this || _global).activatePlayer);
    this.on("uiChange", (this || _global).stopPlayer);
    this.on("pointerDown", (this || _global).stopPlayer);
    this.on("deactivate", (this || _global).deactivatePlayer);
  };

  let proto = Flickity.prototype;

  proto.activatePlayer = function () {
    if (!(this || _global).options.autoPlay) return;

    (this || _global).player.play();

    (this || _global).element.addEventListener("mouseenter", this || _global);
  }; // Player API, don't hate the ... thanks I know where the door is


  proto.playPlayer = function () {
    (this || _global).player.play();
  };

  proto.stopPlayer = function () {
    (this || _global).player.stop();
  };

  proto.pausePlayer = function () {
    (this || _global).player.pause();
  };

  proto.unpausePlayer = function () {
    (this || _global).player.unpause();
  };

  proto.deactivatePlayer = function () {
    (this || _global).player.stop();

    (this || _global).element.removeEventListener("mouseenter", this || _global);
  }; // ----- mouseenter/leave ----- //
  // pause auto-play on hover


  proto.onmouseenter = function () {
    if (!(this || _global).options.pauseAutoPlayOnHover) return;

    (this || _global).player.pause();

    (this || _global).element.addEventListener("mouseleave", this || _global);
  }; // resume auto-play on hover off


  proto.onmouseleave = function () {
    (this || _global).player.unpause();

    (this || _global).element.removeEventListener("mouseleave", this || _global);
  }; // -----  ----- //


  Flickity.Player = Player;
  return Flickity;
});

export default exports;